angular.module('shared').directive('sectionToggle', function() {
  return {
    restrict: 'A',
    link: function($scope, element, attributes) {
      var isAllCheckboxesChecked, sectionCheckboxes, syncSelectAll;
      sectionCheckboxes = function() {
        return element.parent().parent().children();
      };
      element[0].addEventListener('click', function(event) {
        var checked;
        checked = event.target.checked;
        return sectionCheckboxes().each(function(index, node) {
          var input;
          input = angular.element(node).find('input');
          if (input.attr('section-toggle') !== '') {
            return input.prop('checked', checked);
          }
        });
      });
      sectionCheckboxes().each(function(index, node) {
        var input;
        input = angular.element(node).find('input');
        if (input.attr('section-toggle') !== '') {
          return input[0].addEventListener('click', function() {
            return syncSelectAll();
          });
        }
      });
      syncSelectAll = function() {
        var allCheckboxChecked;
        allCheckboxChecked = isAllCheckboxesChecked();
        return angular.element(element[0]).prop('checked', allCheckboxChecked);
      };
      isAllCheckboxesChecked = function() {
        var allChecked;
        allChecked = true;
        sectionCheckboxes().each(function(index, node) {
          var input;
          input = angular.element(node).find('input');
          if (!input.prop('checked') && input.attr('section-toggle') !== '') {
            allChecked = false;
          }
        });
        return allChecked;
      };
      return syncSelectAll();
    }
  };
});
